/**
 *  @class
 *  @function CollectionTabs
 */

if (!customElements.get('collection-tabs-2')) {
  class CollectionTabs2 extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      setTimeout(() => {
        const buttons = Array.from(this.querySelectorAll('button'));
        const sectionHeader = this.closest('.section-header');
        if (!sectionHeader) return; // Ensure the existence of the section header
        const links = sectionHeader.querySelectorAll('.linked-to-tab');
        this.target = this.dataset.target;
        this.slider = document.getElementById(this.target);

        buttons.forEach((button, i) => {
          button.addEventListener('click', (event) => {
            this.toggleButtons(buttons, i);
            this.toggleLinks(links, i);
            if (button.dataset.collection) {
              this.toggleCollection(button.dataset.collection);
            }
            event.preventDefault();
          });
        });
        window.addEventListener('resize', () => {
          if (!this.slider) return; // Ensure the existence of the slider
          let flkty = Flickity.data(this.slider);
          flkty.resize();
        });
        if (Shopify.designMode) {
          this.addEventListener('shopify:block:select', (event) => {
            const index = buttons.indexOf(event.target);
            if (index !== -1) {
              buttons[index].dispatchEvent(new Event('click'));
            }
          });
        }
      }, 10);
    }

    toggleButtons(buttons, index) {
      buttons.forEach((button) => button.classList.remove('active'));
      buttons[index].classList.add('active');
      this.scrollToCenter(buttons[index], index, buttons.length);
    }

    toggleLinks(links, index) {
      if (links.length) {
        links.forEach((link) => link.classList.remove('active'));
        links[index].classList.add('active');
      }
    }

    toggleCollection(handle) {
      const slider = document.getElementById(this.target);
      if (!slider) return; // Ensure the existence of the slider
      const products = slider.querySelectorAll(`.columns:not([data-collection="${handle}"])`);
      const activeProducts = slider.querySelectorAll(`[data-collection="${handle}"]`);
      const flkty = Flickity.data(slider);

      products.forEach((product) => { product.classList.remove('carousel__slide'); slider.append(product); });
      activeProducts.forEach((product) => product.classList.add('carousel__slide'));

      flkty.insert(activeProducts);
      flkty.reloadCells();
      flkty.select(0, 0, 1);
    }

    scrollToCenter(button, index, totalButtons) {
      const container = this;
      const containerWidth = container.offsetWidth;
      const containerScrollWidth = container.scrollWidth;
      
      // Only scroll if container is scrollable
      if (containerScrollWidth > containerWidth) {
        if (index === 0) {
          // First button: scroll to left
          container.scrollTo({
            left: 0,
            behavior: 'smooth'
          });
        } else if (index === totalButtons - 1) {
          // Last button: scroll to right
          container.scrollTo({
            left: containerScrollWidth - containerWidth,
            behavior: 'smooth'
          });
        } else {
          // Middle buttons: scroll to center
          const buttonRect = button.getBoundingClientRect();
          const containerRect = container.getBoundingClientRect();
          const buttonLeft = buttonRect.left - containerRect.left + container.scrollLeft;
          const buttonCenter = buttonLeft + (buttonRect.width / 2);
          const containerCenter = containerWidth / 2;
          const scrollPosition = buttonCenter - containerCenter;
          
          container.scrollTo({
            left: scrollPosition,
            behavior: 'smooth'
          });
        }
      }
    }
  }
  customElements.define('collection-tabs-2', CollectionTabs2);
}
